import Vue from 'vue'
import App from './App.vue'
import axios from './http'
import router from './router'
//import globalWs from './ws'
import store from './store/index'
import config from './variable/js/config'
import config_fun from './variable/js/config_fun'
import flydata from './variable/js/flydata'
import VueCookies from 'vue-cookies'
import Element from 'element-ui'
import PortalVue from 'portal-vue'

import "./assets/css/main.scss"
import "./assets/css/main-jp.scss"
import "../public/assets/mathlive/mathlive.css";
import "../public/assets/mathlive/mathlive.core.css";

import lodash from 'lodash';
let _lodash = {
  clone: lodash.clone,
  cloneDeep: lodash.cloneDeep,
  max: lodash.max,
  merge: lodash.merge,
  includes: lodash.includes,
  isArray: lodash.isArray,
  sumBy: lodash.sumBy,
  isNumber: lodash.isNumber
}
window._ = _lodash;



import Loading from '@/components/loading/loading.js'

//全局组件
import interaction from './components/interaction/index';
import bindParent from './components/bindParent/index';
import firstLogin from './components/firstLogin/index';
import jpAccountExpiredToast from './components/jpAccountExpiredToast/index';


Vue.component('interaction', interaction);
Vue.component('bindParent', bindParent);
Vue.component('firstLogin', firstLogin);
Vue.component('jpAccountExpiredToast', jpAccountExpiredToast);

//将全局变量挂载到vue中
Vue.use(Element)

Vue.use(config)
Vue.use(config_fun)
Vue.use(VueCookies)
Vue.use(Loading)
Vue.use(PortalVue)

Vue.config.productionTip = false

//将flydata挂载到prototype上
Vue.prototype.$flydata = flydata;

// 将axios挂载到prototype上，在组件中可以直接使用this.$http
Vue.prototype.$http = axios;
//Vue.prototype.$ws = globalWs;

VueCookies.config('365d');

//错误处理
Vue.prototype.$msg = {
  error: (err => {
    return console.error({
      message: '接口请求失败',
      type: 'error',
      info: err
    })
  })
}

//初始化根元素
function initHtmlFontSize() {
  var url = window.location.href;
  var deviceWidth = document.documentElement.clientWidth;
  if (deviceWidth >= 330) {
    deviceWidth = 860;
  } else {
    deviceWidth = 688
  }

  document.documentElement.style.fontSize = deviceWidth / 8.6 + 'px';
  let link = document.getElementById("link-icon");
  link.href = localStorage.getItem("common_favicon");
  // document.title = Vue.prototype.judeIsElectron() ? '爱米云课件' : localStorage.getItem("common_page_title");
  document.title = localStorage.getItem("common_page_title");
  sessionStorage.setItem('window_location_href',window.location.href);
}

window.addEventListener("resize", function () {
  initHtmlFontSize();
})

initHtmlFontSize();

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
